/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import {
    INodeProps,
    Module,
    Node,
    Button
    // NodeTag
} from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';
import {
    IProductCollectionViewProps,
    IProductComponentViewProps
} from '@msdyn365-commerce-modules/product-collection/src/modules/product-collection/./product-collection';
import { IProductCollectionProps, IProductCollectionResources } from './../definition-extensions/product-collection.ext.props.autogenerated';
import { IProductCollectionData } from './product-collection.data';
import { Category, TextValueTranslation } from '@msdyn365-commerce/retail-proxy';
import Slider from 'react-slick';
import { IFestivalCategory, IFestivalActivitiesStaticSubNavItems } from '../../../utilities/interfaces';
import { msdyn365Commerce } from '@msdyn365-commerce/core';
import { FestivalSVG } from '../../../utilities/icons';

const ProductCollectionView: React.FC<IProductCollectionViewProps & IProductCollectionProps<IProductCollectionData>> = (props) => {
    const {
        heading,
        ProductCollectionContainer,
        products,
        SingleSlideCarouselComponentProps,
        GridComponentProps,
        isCarousel,
        seeAllButton,
        resources,
        context: { request: { apiSettings: { baseImageUrl }, locale, sitePath, textDirection } },
        config: { linkText, categoryIdsToShow, autoPlay, autoplaySpeed, pauseOnMouseHover },
        app: { config: { festivalActivities, festivalActivitiesStaticSubNavItems } },
        data: { categories }
    } = props;

    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 4,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 1199,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1

                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }

        ],
        [textDirection]: true,
        autoplay: autoPlay,
        autoplaySpeed: autoplaySpeed ? autoplaySpeed : 0,
        pauseOnHover: pauseOnMouseHover
    };
    /*VSI | CUSTOMIZATION | START */
    let szfCategories = categories.result?.filteredCategories;
    let sortedCategories: Category[] = [];
    if (categoryIdsToShow && categoryIdsToShow?.length > 0) {
        categoryIdsToShow?.map((categoryId) => {
            const filteredCategory = szfCategories?.find((category) => categoryId === category.RecordId);
            sortedCategories?.push(filteredCategory!);
        });
    }
    sortedCategories = sortedCategories.filter((i)=>i)
    if (props.config.useAsCategoryCollection) {
        const imageBaseURL = baseImageUrl?.substring(0, baseImageUrl?.length - 1);
        return (
            <>
                {/* <Slider {...settings}> */}
                {/* <div className="festival-activities-item__img">
                    <img src="https://images-ap-prod.cms.commerce.dynamics.com/cms/api/rwrswxpkjb/imageFileData/MBNqx?ver=4998" />
                    <h3>{'Event & Shows'}</h3>
                </div> */}
                {/* </Slider> */}
                <Module {...ProductCollectionContainer}>
                    {/* {heading} */}
                    {/* {seeAllButton} */}
                    <Slider {...settings}>
                        {sortedCategories && sortedCategories.map(
                            (categoryItem, index) => {
                                return _rendercategory(categoryItem, index, imageBaseURL, linkText!, festivalActivities, locale, sitePath!, festivalActivitiesStaticSubNavItems);
                            }
                        )}
                    </Slider>
                    {/* {_renderCategoryCarousel(SingleSlideCarouselComponentProps, categories)} */}
                </Module>
            </>
        );
    }
    /*VSI | CUSTOMIZATION | END */
    if (products) {
        return (
            <Module {...ProductCollectionContainer}>
                {heading}
                {seeAllButton}

                {isCarousel ? _renderCarousel(SingleSlideCarouselComponentProps, products) : _renderGrid(GridComponentProps, products)}
            </Module>
        );
    }
    // upgrade-v40
    // If no products are retrieved and the list type is promotional, still render the module to keep the entry of promotion page
    if (props.config.productCollection.listType === 'promotional') {
        return (
            <Module {...ProductCollectionContainer}>
                {heading}
                {seeAllButton}
                {_renderNoProduct(resources)}
            </Module>
        );
    }
    props.context.telemetry.error('Product collection content is empty, module wont render.');
    return null;
};

// const wrapCategories = (categoryList:Category[])=>{
//     return categoryList.map((item,index)=>{
//         return (

//         )
//     })
// }

const _renderCarousel = (carouselContainer: INodeProps, items: IProductComponentViewProps[]): JSX.Element => {
    return <Node {...carouselContainer}>{items && items.map(_renderProduct)}</Node>;
};

const _renderGrid = (gridContainer: INodeProps, items: IProductComponentViewProps[]): JSX.Element => {
    return <Node {...gridContainer}>{items && items.map(_renderProduct)}</Node>;
};

// upgrade-v40
const _renderNoProduct = (resources: IProductCollectionResources): JSX.Element => {
    return (
        <Node className={''}>
            <p>{resources.noProductToRenderText}</p>
        </Node>
    );
};

const _renderProduct = (product: IProductComponentViewProps): JSX.Element => {
    const { ProductContainer, productComponent } = product;

    return <Node {...ProductContainer}>{productComponent}</Node>;
};
const _rendercategory = (
    category: Category,
    index: number,
    imageBaseURL: string,
    linkText: string,
    festivalActivities: IFestivalCategory[],
    locale: string,
    sitePath: string,
    festivalActivitiesStaticSubNavItems: IFestivalActivitiesStaticSubNavItems[]
): JSX.Element => {
    // let imagesource = category && category.Images && category?.Images[0].Uri;
    // imagesource = imagesource?.replace('^', ' ');
    //     imagesource = imagesource?.replace('/', ' ');
    //     const spaceIndex = imagesource?.indexOf(' ');
    //     imagesource = imagesource?.substring(0, spaceIndex) + '/' + imagesource?.substring(spaceIndex! + 1);
    // let imageUrl = generateImageUrl(imagesource, props.context.request.apiSettings);

    // imageUrl = imageUrl?.replace('%2F', '/');
    // let imageUrl = generateImageUrl(ImageName, props.navProps.context.request.apiSettings);
    const translatedText = category?.NameTranslations?.find((item: TextValueTranslation) => item.Language?.toLowerCase().includes(locale.toLowerCase()));
    const handleOpenPlpSubCategory = (categoryId: number, categoryName: string | undefined): string => {
        const isSubCategory = festivalActivities.find((item: IFestivalCategory) => item.categoryId === categoryId);
        const isStaticNavItem = festivalActivitiesStaticSubNavItems.find((item: IFestivalActivitiesStaticSubNavItems) => categoryName?.toLowerCase().includes(item.categoryName.toLowerCase()));
        return isStaticNavItem ? `${window.location.origin}${sitePath}/festival-activities/${isStaticNavItem.categoryName?.toLowerCase()?.replace(/ /g,'-').replace('&','and')}` : !isSubCategory ? `${window.location.href}/sub-festival-activities/${categoryName?.replace(/&/g, "and").replace(/\s/g, "-").toLowerCase()}?categoryId=${categoryId}` : `${window.location.origin}${sitePath}/all/festival-activities/${categoryName?.replace(/&/g, "and").replace(/\s/g, "-")?.toLowerCase()}/${categoryId}.c`;
    };

    return (
        <div key={index} className="festival-activities-item">
            {/* <div className='accessories-slider-slide slide slick-slide slick-current slick-active'> */}
            <div className="festival-activities-item__img">
                <img src={`${imageBaseURL}${category?.Name?.replace('&','And').replace(/\b(?<!')[a-z]/g, (match) => match.toUpperCase()).replace(',','')}__home__000.png`} />
            </div>
            <a className='msc-product'>
                <div className='msc-product__img'>
                    <FestivalSVG />
                </div>
                <h2 className='msc-product__title'>{translatedText?.Text!}</h2>
            </a>
            <div className="festival-activities-item__desc">
                <div>
                    <div>{category?.LocalizedDescription!}</div>
                </div>
            </div>
            <div className={`festival-activities-item__cta`}>
                {
                    msdyn365Commerce.isBrowser && window && (
                        <Button
                            href={handleOpenPlpSubCategory(category?.RecordId!, category?.Name!)}
                            name={category?.Name!}
                            id={`${category?.RecordId!}`}
                        >
                            {linkText || `Read More`}
                        </Button>
                    )
                }
            </div>
        </div>
    );
};
// const _rendercategory = (category: Category, index: number): JSX.Element => {
//     const ProductContainer = {
//         tag: 'li' as NodeTag,
//         className: 'ms-product-collection__item',
//         role: 'listitem',
//         key: index,
//     };
//     return (
//         <Node {...ProductContainer}>
//             <div className='accessories-slider-slide slide slick-slide slick-current slick-active'>
//                 <a className='msc-product'>
//                     <h2 className='msc-product__title'>{category.Name}</h2>
//                 </a>
//                 <div>
//                     <div>
//                         <div>{category.LocalizedDescription}</div>
//                     </div>
//                 </div>

//             </div>
//         </Node>
//     );
// };
// const _renderCategoryCarousel = (carouselContainer: INodeProps, items: Category[]): JSX.Element => {
//     return <Node {...carouselContainer}>{items && items.map(_rendercategory)}</Node>;
// };

export default ProductCollectionView;
